import React from 'react';
import { IconFacebook, IconInstagram, IconTwitter, IconYoutube } from 'edx-shared/src/components/icons'; // TS is not compiling if @edx alias is used

const COLUMN_1 = {
  sections: [
    {
      sectionName: 'Escuela',
      items: [
        { item: 'Cursos', resourcePath: '/cursos' },
        { item: 'Repertorio', resourcePath: '/repertorio' },
        { item: 'Itinerarios', resourcePath: '/itinerarios' },
        { item: 'Ejercicios', resourcePath: '/ejercicios' },
        { item: 'Consejos', resourcePath: '/consejos' },
        { item: 'Q&A', resourcePath: '/preguntas-y-respuestas' },
        { item: 'Cómo funciona', resourcePath: '/como-funciona' },
      ],
    },
  ],
};

const COLUMN_2 = {
  sections: [
    {
      sectionName: 'Profesores',
      items: [
        { item: 'Profesores', resourcePath: '/profesores' },
        { item: 'Miki Santamaría', resourcePath: '/miki-santamaria' },
      ],
    },
    {
      sectionName: 'Comunidad',
      items: [{ item: 'Foro', resourcePath: '/comunidad' }],
    },
  ],
};

const COLUMN_3 = {
  sections: [
    {
      sectionName: 'Suscripción',
      items: [
        { item: 'Precio', resourcePath: '/precio' },
        { item: 'Regala EDB', resourcePath: '/regala-edb' },
      ],
    },
    {
      sectionName: 'Backstage',
      items: [{ item: 'Contacta', resourcePath: '/contacto' }],
    },
  ],
};

const COLUMN_4 = {
  sections: [
    {
      hideLoggedIn: true,
      sectionName: 'Zona de usuario',
      items: [
        { item: 'Accede', resourcePath: '/login' },
        { item: 'Regístrate', resourcePath: '/precio' },
      ],
    },
    {
      sectionName: 'Síguenos',
      inlineItems: true,
      items: [
        { item: <IconFacebook />, resourcePath: 'https://www.facebook.com/escueladebajistas' },
        { item: <IconYoutube />, resourcePath: 'https://www.youtube.com/channel/UCmwSgh_GsuLRbWIuU_evPGg' },
        { item: <IconInstagram />, resourcePath: 'https://www.instagram.com/escueladebajistas/' },
        { item: <IconTwitter />, resourcePath: 'https://www.twitter.com/EscuelaBajistas' },
      ],
    },
  ],
};

export const FOOTER_COLUMNS = [COLUMN_1, COLUMN_2, COLUMN_3, COLUMN_4];
